import { useAllStatsCOM } from '../../../../../hooks/fetchers/useAllStatsCOM/useAllStatsCOM';
import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';
import { Bar, Line } from 'react-chartjs-2';
import moment from 'moment';
import { useMemo } from 'react';
import { usePlansENT } from '../../../../../hooks/fetchers/usePlansENT/usePlansENT';

export default () => {
  const { data: allStats } = useAllStatsCOM();

  const { data: plansENT } = usePlansENT();

  const wonStats = useMemo(
    () =>
      [...Array(6)]
        .map((_, index) => {
          // allStats?.won.reduce((acc, { count }) => [...acc, count], [] as number[])
          const [month, year] = moment().subtract(index, 'month').format('M,Y').split(',');
          return (
            allStats?.won.find(
              (item) => item.month === parseInt(month) && item.year === parseInt(year)
            )?.count || 0
          );
        })
        .reverse(),
    [allStats]
  );

  const lostStats = useMemo(
    () =>
      [...Array(6)]
        .map((_, index) => {
          // allStats?.won.reduce((acc, { count }) => [...acc, count], [] as number[])
          const [month, year] = moment().subtract(index, 'month').format('M,Y').split(',');
          return (
            allStats?.lost.find(
              (item) => item.month === parseInt(month) && item.year === parseInt(year)
            )?.count || 0
          );
        })
        .reverse(),
    [allStats]
  );

  const totalStats = useMemo(
    () =>
      [...Array(6)]
        .map((_, index) => {
          // allStats?.total.reduce((acc, { count }) => [...acc, count], [] as number[])
          const [month, year] = moment().subtract(index, 'month').format('M,Y').split(',');
          return (
            allStats?.total.find(
              (item) => item.month === parseInt(month) && item.year === parseInt(year)
            )?.count || 0
          );
        })
        .reverse(),
    [allStats]
  );

  const ratioStats = useMemo(
    () =>
      [...Array(6)]
        .map((_, index) => {
          // allStats?.win_ratio.reduce((acc, { ratio }) => [...acc, ratio], [] as number[])
          const [month, year] = moment().subtract(index, 'month').format('M,Y').split(',');
          const ratio =
            allStats?.win_ratio.find(
              (item) => item.month === parseInt(month) && item.year === parseInt(year)
            )?.ratio || 0;
          return ratio > 0 ? ratio * 100 : 0;
        })
        .reverse(),
    [allStats]
  );

  const averageStats = useMemo(
    () =>
      [...Array(6)]
        .map((_, index) => {
          // allStats?.win_ratio.reduce((acc, { ratio }) => [...acc, ratio], [] as number[])
          const [month, year] = moment().subtract(index, 'month').format('M,Y').split(',');
          const average =
            allStats?.win_average.find(
              (item) => item.month === parseInt(month) && item.year === parseInt(year)
            )?.average || 0;
          return average;
        })
        .reverse(),
    [allStats]
  );

  const planStats = useMemo(
    () =>
      plansENT?.map((currentPlan) => {
        return allStats?.plan.find((item) => item.plan === currentPlan.plan_name)?.count;
      }),
    [allStats, plansENT]
  );

  const datasets = [
    {
      label: 'Gagné',
      data: wonStats,
      borderColor: '#DE5835',
      backgroundColor: '#DE583550',
    },
    {
      label: 'Perdu',
      data: lostStats,
      borderColor: 'rgb(153, 62, 235)',
      backgroundColor: 'rgba(153, 62, 235, 0.5)',
    },
    {
      label: 'Démarché',
      data: totalStats,
      borderColor: '#206C87',
      backgroundColor: '#206C8750',
    },
  ];

  return (
    <DashboardLayout>
      <section className="dashboard__stats">
        <div className="dashboard__stats-box">
          <Line
            datasetIdKey="id"
            data={{
              labels: [...Array(6)]
                .map((_, index) => moment().subtract(index, 'months').format('MMMM'))
                .reverse(),
              datasets,
            }}
          />
        </div>
        <div className="dashboard__stats-box">
          <Bar
            datasetIdKey="id"
            data={{
              labels: plansENT?.map((plan) => plan.plan_name),
              datasets: [
                {
                  label: 'Plan',
                  data: planStats,
                  borderColor: '#DE5835',
                  backgroundColor: '#DE583575',
                },
              ],
            }}
          />
        </div>
        <div className="dashboard__stats-box">
          <Line
            datasetIdKey="id"
            options={{
              scales: {
                y: {
                  min: 0,
                  max: 100,
                  ticks: {
                    callback: (value) => value + '%',
                  },
                },
              },
            }}
            data={{
              labels: [...Array(6)]
                .map((_, index) => moment().subtract(index, 'months').format('MMMM'))
                .reverse(),
              datasets: [
                {
                  label: 'Ratio de gains',
                  data: ratioStats,
                  borderColor: '#DE5835',
                  backgroundColor: '#DE583575',
                },
              ],
            }}
          />
        </div>
        <div className="dashboard__stats-box">
          <Line
            datasetIdKey="id"
            data={{
              labels: [...Array(6)]
                .map((_, index) => moment().subtract(index, 'months').format('MMMM'))
                .reverse(),
              datasets: [
                {
                  label: 'Moyenne de ventes par jour',
                  data: averageStats,
                  borderColor: '#DE5835',
                  backgroundColor: '#DE583575',
                },
              ],
            }}
          />
        </div>
      </section>
    </DashboardLayout>
  );
};
